import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

import { usePalletUnitsInput } from '../model/use-pallet-units-input';
import type { PalletUnitsField } from '../model/types';

/** Units of a line on a pallet, out of the whole line: `[30] / 50 Each` */
export function PalletUnitsInput({ units, max, total, unit, disabled, onCommit }: PalletUnitsField) {
  const { t } = useTranslation();
  const input = usePalletUnitsInput({ units, max, onCommit });

  return (
    <div className="flex items-center gap-2">
      <Input
        type="number"
        min={0}
        max={max}
        {...input}
        disabled={disabled}
        className="h-8 w-20"
        aria-label={t('requestline.ltuQty.short')}
      />
      <span className="text-sm whitespace-nowrap">
        / {total} {unit}
      </span>
    </div>
  );
}
